import React, { useState, useEffect, useContext, useMemo } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
// import { AppContext } from "AppContext";
import TableAllData from "components/Content/CustomTable/TableAllData";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { Box } from "@mui/material";

import LoaderAnimation from "pages/LoaderAnimation";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import { Utils } from "common/Utils";
import AximDropdown from "components/Dropdown/AximDropdown";

const formatSSN = (val) => "XXX-XX-" + val.replaceAll("-", "").slice(5);

function GsgCensus (props) {
  const { companyId } = useContext(PrivateRoutesContext);
  // const { oauthToken, setOauth } = useContext(AppContext);
  const [fetchedData, setFetchedData] = useState([]);

  const [isLoadingCensus, setIsLoadingCensus] = useState(true);

  const [benefitTypeSelected, setBenefitTypeSelected] = useState("ALL");
  const [benefitDatesDropdown, setbenefitDatesDropdown] = useState([]);
  const [benefitDateSelected, setBenefitDateSelected] = useState("");
  
  const benefitTypesDropdown = [{ value: "ALL", text: "All Benefits" }, { value: "MEDICAL", text: "Medical Only" }];


  useEffect(() => {
    fetchDropdownData();
  }, [companyId]);

  const fetchDropdownData = () => {
    apiGet(apiUrls.getBenefitPayPeriods(companyId))
      .then((response) => {
        if (response.data)
        {
          var date = new Date(getDefaultBenefitDate(response.data));

          // restrict benefit dates to dates within the next 4 months
          var fourMonths =  new Date(date.setMonth(date.getMonth()+4));

          var dates = response.data.filter(d => new Date(d.benefitDate) < fourMonths);

          setbenefitDatesDropdown(dates)
        }
      })
      .catch(function (error) {
      })
      .then(function () {
      });
  }

  useEffect(() => {
    if (benefitDatesDropdown.length > 0) {
      var date = getDefaultBenefitDate(benefitDatesDropdown);
      
      setBenefitDateSelected(date);
    }
  }, [benefitDatesDropdown]);

  useEffect(() => {
    fetchCensusData();
  },[benefitDateSelected, benefitTypeSelected]);

  const fetchCensusData = () => {
    if (benefitDateSelected && benefitTypeSelected) {
      setIsLoadingCensus(true);
      
      apiGet(apiUrls.getEmployeesWithEnrollmentInfo(companyId, benefitDateSelected, benefitTypeSelected)).then(
        (empResponse) => {
          if (empResponse.data) {
            setFetchedData(empResponse.data);
          }
          setIsLoadingCensus(false);
        }
      );
    }
  }

  const getDefaultBenefitDate = (dates) => {
    var date = dates[0];

    let closed = dates.filter(x => x.statusCode === 'CLOSE');
    let open = dates.filter(x => x.statusCode === "OPEN");

    if (closed.length > 0) {
      // sort descending
      var orderedClosed = closed.sort((a,b) => new Date(b.benefitDate) - new Date(a.benefitDate));

      date = orderedClosed[0].benefitDate;
    }
    else if (open.length > 0) {
      // sort ascending
      var orderedOpen = open.sort((a,b) => new Date(a.benefitDate) - new Date(b.benefitDate));

      date = orderedOpen[0].benefitDate;
    }

    return date;
  }

  const showBenefits = (benefits) => {
    return (<table>
      {
        Array.isArray(benefits) ?
          benefits.map((enrollment) => {
            return (<tr class="sub"><td class="sub"></td><td class="sub">{enrollment.benefit}</td><td class="sub">{ (enrollment.benefit.toUpperCase().includes("WAIVE")?(" ("+Utils.formatDate(enrollment.startDate)+" to "+Utils.formatDate(enrollment.endDate) +")"+((benefits.length>1)?"\n":"")):" : "+enrollment.coverage+" ("+Utils.formatDate(enrollment.startDate)+" to "+Utils.formatDate(enrollment.endDate) +")"+((benefits.length>1)?"\n":""))}</td></tr>);
          }) : (<></>)
      }
    </table>);
  }

  const columns = [
    {
      Header: "InsuredID",
      accessor: "insuredID",
      disableFilters: true,
    },
    {
      Header: "benefitPackageID",
      accessor: "benefitPackageID",
      disableFilters: true,
    },
    {
      Header: "First Name",
      accessor: "firstName",
    },
    {
      Header: "Last Name",
      accessor: "lastName",
    },
    // {
    //   Header: "Email",
    //   accessor: "email",
    // },
    {
      Header: "SSN",
      accessor: "ssn",
      Cell: ({ row }) => (
        <Box >
          {formatSSN(row.values.ssn)}
        </Box>
      )
    },
    {
      Header: "DOB",
      accessor: (cell) => Utils.formatDate(cell.birthDateStr),
      Cell: ({ row }) => (
        <Box>
          {Utils.formatDate(row.original.birthDateStr)}
        </Box>
      ),
      sortType: "dateSort",
    },
    {
      Header: "DOH",
      accessor: (cell) => Utils.formatDate(cell.hireDateStr),
      Cell: ({ row }) => (
        <Box>
          {Utils.formatDate(row.original.hireDateStr)}
        </Box>
      ),
      sortType: "dateSort",
    },
    // {
    //   Header: "Term Date",
    //   accessor: (cell) => Utils.formatDate(cell.termDateStr),
    //   Cell: ({row}) => (
    //     <Box>
    //       {Utils.formatDate(row.original.termDateStr)}
    //     </Box>
    //   ),
    //   sortType: "dateSort",
    // },
    {
      Header: "Benefits",
      accessor: "benefitEnrollments",
      //accessor: (cell) => < />,
      Cell: ({ row }) => (
        <Box >
          {showBenefits(row.values.benefitEnrollments)}
        </Box>
      )
    }
  ];

  const downloadBenefits = () => {
    if (benefitDateSelected && benefitTypeSelected) {
      
      apiGet(apiUrls.exportEmployeesWithEnrollmentInfo(companyId, benefitDateSelected, benefitTypeSelected)).then(response => {
  
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "export.csv");
        document.body.appendChild(link);
        link.click();
  
        console.log("File downloading successfully");
      }).catch(
        (response) => {
        }
      );

      
    }
  }
  return (
    <>
      <div>
        <Box className="container-fluid">
          <Box className="d-flex justify-content-start">

            <AximDropdown
              label="Benefit Date"
              value={benefitDateSelected}
              handleChange={(e) => setBenefitDateSelected(e.target.value)}
              pairs={benefitDatesDropdown.map(x => ({ value: x.benefitDate, text: Utils.formatDate(x.benefitDate) }))} />

            <AximDropdown
              label="Benefit Types"
              value={benefitTypeSelected}
              handleChange={(e) => setBenefitTypeSelected(e.target.value)}
              pairs={benefitTypesDropdown} />

          </Box>
        </Box>
        {/* Census Table Data */}
        <div
          className={`${TableStyle.tableWrapper}`}
        >
          {isLoadingCensus ? (
            <LoaderAnimation />
          ) :
            (<TableAllData columns={columns} data={fetchedData} initialState={{ hiddenColumns: ['insuredID','benefitPackageID'] }} download={{ prefix: "Census", table: "GsgCensus" }} downloadMethod={downloadBenefits}/>)}
        </div>
      </div>
    </>
  );
}

export default GsgCensus;
